import Api from '@/services/Api'

export default {
  actual () {
    return Api().get('account/actual')
  },
  bets (params) {
    return Api().post('account/bets', params)
  },

  payments (params) {
    return Api().post('account/payments', params)
  },
  deposit (params) {
    return Api().post('account/deposit', params)
  },
  depositAzx (params) {
    return Api().post('account/depositAzx', params)
  },
  withdrawal (params) {
    return Api().post('account/withdrawal', params)
  },
  notPaymentWithdrawal (params) {
    return Api().get('account/notPaymentWithdrawal')
  },
  rejectPayment (params) {
    return Api().post('account/rejectPayment', params)
  },
  depositCard (params) {
    return Api().post('account/depositCard', params)
  },

  profile () {
    return Api().get('account/profile')
  },
  bonuses () {
    return Api().get('account/bonuses')
  },

  setting (params) {
    return Api().post('account/setting', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/AccountService.js